import Vue from 'vue'


import checkbox from './checkbox'
Vue.component('g-checkbox', checkbox)
